<script setup lang="ts">
import { computed, CSSProperties } from "vue";

// Inspired by:
//                  https://loading.io/css/
// (added dynamic size and line width via css)

/**
 * USAGE:
 *
 * Create a wrapper around this control. This spinner will then
 * use the wrappers *width* and *height*.
 *
 * The wrappers *font-size* is used to change the spinners line
 * width.
 *
 * The wrappers *border-color* is used to the the spinners color.
 *
 * e.g.:
 * .spinnerWrapper{
 *   // sets spinner size:
 *   height: 6em;
 *   width: 6em;
 *
 *   // sets spinner line width:
 *   font-size: 6px;
 * }
 */

defineOptions({ name: "BcSpinner" });

const props = defineProps({
  spinnerColor: { type: String, default: "#c9c9c9" },
  fontSize: { type: String, default: "3px" },
  width: { type: String, default: "24px" },
  height: { type: String, default: "24px" },
});

const spinnerStyle = computed<CSSProperties>(() => {
  return {
    "--spinner-color": props.spinnerColor,
    "--spinner-font-size": props.fontSize,
    "--spinner-width": props.width,
    "--spinner-height": props.height,
  };
});
</script>

<template>
  <div class="bissantzControls spinnerControl" :style="spinnerStyle">
    <div class="spinnerContianer">
      <div class="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<style lang="less">
@import "../styles/components/bc-spinner.less";
</style>
